/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  AdminDeleteZoneParams,
  AdminHoldZoneParams,
  AdminListZonesParams,
  AdminZoneCreateRequest,
  AdminZoneCreateResponse,
  AdminZoneDeleteResponse,
  AdminZoneHoldZoneResponse,
  AdminZoneListResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useAdminListZonesHook = () => {
        const adminListZones = useCustomInstance<AdminZoneListResponse>();

        return useCallback((
    params?: AdminListZonesParams,
 signal?: AbortSignal
) => {
        return adminListZones(
          {url: `/AdminZone/List`, method: 'GET',
        params, signal
    },
          );
        }, [adminListZones])
      }
    

export const getAdminListZonesQueryKey = (params?: AdminListZonesParams,) => {
    return [`/AdminZone/List`, ...(params ? [params]: [])] as const;
    }

    
export const useAdminListZonesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError = unknown>(params?: AdminListZonesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListZonesQueryKey(params);

  const adminListZones =  useAdminListZonesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>> = ({ signal }) => adminListZones(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListZonesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>>
export type AdminListZonesQueryError = unknown


export function useAdminListZones<TData = Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError = unknown>(
 params: undefined |  AdminListZonesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListZones<TData = Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError = unknown>(
 params?: AdminListZonesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListZones<TData = Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError = unknown>(
 params?: AdminListZonesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminListZones<TData = Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError = unknown>(
 params?: AdminListZonesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListZonesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useAdminListZonesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useAdminCreateZonesHook = () => {
        const adminCreateZones = useCustomInstance<AdminZoneCreateResponse>();

        return useCallback((
    adminZoneCreateRequest: AdminZoneCreateRequest,
 signal?: AbortSignal
) => {
        return adminCreateZones(
          {url: `/AdminZone/Create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminZoneCreateRequest, signal
    },
          );
        }, [adminCreateZones])
      }
    


export const useAdminCreateZonesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminCreateZonesHook>>>, TError,{data: AdminZoneCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminCreateZonesHook>>>, TError,{data: AdminZoneCreateRequest}, TContext> => {

const mutationKey = ['adminCreateZones'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const adminCreateZones =  useAdminCreateZonesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminCreateZonesHook>>>, {data: AdminZoneCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateZones(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateZonesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminCreateZonesHook>>>>
    export type AdminCreateZonesMutationBody = AdminZoneCreateRequest
    export type AdminCreateZonesMutationError = unknown

    export const useAdminCreateZones = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminCreateZonesHook>>>, TError,{data: AdminZoneCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAdminCreateZonesHook>>>,
        TError,
        {data: AdminZoneCreateRequest},
        TContext
      > => {

      const mutationOptions = useAdminCreateZonesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useAdminDeleteZoneHook = () => {
        const adminDeleteZone = useCustomInstance<AdminZoneDeleteResponse>();

        return useCallback((
    params?: AdminDeleteZoneParams,
 ) => {
        return adminDeleteZone(
          {url: `/AdminZone/Delete`, method: 'DELETE',
        params
    },
          );
        }, [adminDeleteZone])
      }
    


export const useAdminDeleteZoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminDeleteZoneHook>>>, TError,{params?: AdminDeleteZoneParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminDeleteZoneHook>>>, TError,{params?: AdminDeleteZoneParams}, TContext> => {

const mutationKey = ['adminDeleteZone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const adminDeleteZone =  useAdminDeleteZoneHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminDeleteZoneHook>>>, {params?: AdminDeleteZoneParams}> = (props) => {
          const {params} = props ?? {};

          return  adminDeleteZone(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteZoneMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminDeleteZoneHook>>>>
    
    export type AdminDeleteZoneMutationError = unknown

    export const useAdminDeleteZone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminDeleteZoneHook>>>, TError,{params?: AdminDeleteZoneParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAdminDeleteZoneHook>>>,
        TError,
        {params?: AdminDeleteZoneParams},
        TContext
      > => {

      const mutationOptions = useAdminDeleteZoneMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useAdminHoldZoneHook = () => {
        const adminHoldZone = useCustomInstance<AdminZoneHoldZoneResponse>();

        return useCallback((
    params?: AdminHoldZoneParams,
 signal?: AbortSignal
) => {
        return adminHoldZone(
          {url: `/AdminZone/HoldZone`, method: 'POST',
        params, signal
    },
          );
        }, [adminHoldZone])
      }
    


export const useAdminHoldZoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminHoldZoneHook>>>, TError,{params?: AdminHoldZoneParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminHoldZoneHook>>>, TError,{params?: AdminHoldZoneParams}, TContext> => {

const mutationKey = ['adminHoldZone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const adminHoldZone =  useAdminHoldZoneHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminHoldZoneHook>>>, {params?: AdminHoldZoneParams}> = (props) => {
          const {params} = props ?? {};

          return  adminHoldZone(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminHoldZoneMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminHoldZoneHook>>>>
    
    export type AdminHoldZoneMutationError = unknown

    export const useAdminHoldZone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminHoldZoneHook>>>, TError,{params?: AdminHoldZoneParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAdminHoldZoneHook>>>,
        TError,
        {params?: AdminHoldZoneParams},
        TContext
      > => {

      const mutationOptions = useAdminHoldZoneMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    